// Generate required css
import materialIcons from 'react-native-vector-icons/Fonts/MaterialIcons.ttf';
import ioniconsIcons from 'react-native-vector-icons/Fonts/Ionicons.ttf';

const materialIconFontStyles = `@font-face {
  src: url(${materialIcons});
  font-family: MaterialIcons;
}
`;

const ioniconIconFontStyles = `@font-face {
  src: url(${ioniconsIcons});
  font-family: Ionicons;
}
`;

// Create stylesheet
const style = document.createElement('style');
style.appendChild(document.createTextNode(materialIconFontStyles));
style.appendChild(document.createTextNode(ioniconIconFontStyles));

// Inject stylesheet
document.head.appendChild(style);
